<template>
	<Card>
		<div class="yl-flex" style="width: 380px">
			<Input v-model="name" style="width: 250px" placeholder="请输入名称">
			<i-button slot="append" icon="ios-search"></i-button>
			</Input>
			<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
			<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
			<Button class='ivu-btn-circle' type="primary" @click="addChannelName">添加渠道公司</Button>
		</div>
		<div style="margin-top: 20px;">
			<Table size="small" :columns="columns" :data="data" >
			</Table>
			<div class="pager1">
				<Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-total
					show-elevator />
			</div>
		</div>
		<Modal v-model="modal" width="500" ok-text="添加保存">
			    <Form :model="company" :label-width="80">
			        <FormItem label="渠道公司全称">
			            <Input v-model="company.company_name" placeholder="请输入公司全称"></Input>
			        </FormItem>
					<FormItem label="合作状态">
						<Select v-model="company.status">
							<Option value=0>正常合作</Option>
							<Option value=1>暂停合作</Option>
						</Select>
					</FormItem>					
					<FormItem label="联系人">
					    <Input v-model="company.contacts" placeholder="请输入联系人"></Input>
					</FormItem>
					<FormItem label="需求城市">
					    <Input v-model="company.city" placeholder="请输入客户投放城市"></Input>
					</FormItem>
					<FormItem label="备注">
					    <Input v-model="company.des" placeholder="请输入备注"></Input>
					</FormItem>
			    </Form>
			<div slot="footer">
				<Button type="primary" @click="save()">保存</Button>
			</div>
		</Modal>
		<Modal v-model="delModal" width="360">
			<p slot="header" style="color:#f60;text-align:center">
				<Icon type="ios-information-circle"></Icon>
				<span>Delete confirmation</span>
			</p>
			<div style="text-align:center">
				<p>After this task is deleted, the downstream 10 tasks will not be implemented.</p>
				<p>Will you delete it?</p>
			</div>
			<div slot="footer">
				<Button type="error" size="large"  @click="del">Delete</Button>
			</div>
		</Modal>		
	</Card>
</template>

<script>
	import {
		mapGetters,
		mapActions
	} from "vuex";
	import { getChannelName,saveChannelName,getCompany } from '@/api/runSet';
	export default {
		name: "ChannelName",
		computed: {
			...mapGetters(['userInfo', 'token']),
		},
		created() {
			this.getList();
		},
		data(){
			return{
				columns:[
					{
						title: 'ID',
						key: 'id',
						width: '100',
						"align":"center",
					},
					{
						title:'渠道名称',
						key:'company_name',
						"align":"center",
					},
					{
						title: '城市',
						key: 'city',
						"align":"center",
					},
					{
						title: '状态',
						key: 'status',
						"align":"center",
					},
					{
						title: '备注',
						key: 'des',
						"align":"center",
					},
					{
                        title: '操作',
                        key: 'action',
                        width: 150,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.editCompany(params.row)
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.delCompany(params.row)
                                        }
                                    }
                                }, '删除')
                            ]);
                        }
						},
						
				],
				company:{
					company_name:'',
					contacts:'',
					city:'',
					des:'',
					status:'',
				},
				modal:false,
				data:[],
				delModal:false,
				count: 0,
				page: 1,
				name:'',
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			async getList(){
				let that = this;
				let data = {
					token:that.token,
					page: that.page,
					name: that.name,
				}
				let res = await getChannelName(that,data);
				if(res.code == 1){
					that.data = res.data.list;
					that.count = res.count;
				}
			},
			search() {
				this.page = 1;
				this.getList();
			},				
			addChannelName(){
				this.initSearch();
				this.modal = true;
			},
			del(){
				this.delModal = true;
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			// 编辑公司
			async editCompany(e) {
				let that = this;
				let id = e.id;
				let data = {
					token: that.token,
					id: id
				};
				let res = await getCompany(that, data);
				if (res.code == 1) {
					that.company = res.data.item;
					that.modal = true;
				}
			},
			initSearch() {
				this.name = '';
				this.company={
					company_name:'',
					contacts:'',
					city:'',
					des:'',
					status:'',
				};
				this.page = 1;
			},
			async delCompany(e){
				let that = this;
				let id = e.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async() => {
						that.throttle(async function () {
						let data = {
							token:that.token,
							data:{
								id:id
							},
							del:1,
						}
						let res = await saveChannelName(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})			
			},
			async save(){
				let that = this;
				let data = {
					token:that.token,
					data:that.company,
				}
				let res = await saveChannelName(that,data);
				if(res.code == 1){
					this.modal = false;
					this.getList();
				}
			}
					
		}
	}
</script>
<style scoped lang="less">
	.yl-flex {
		display: flex;
		justify-content: space-between;
		padding-bottom: 0;
	}

	.add_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;
	}

	.add_title {
		margin: 0 10px;
		font-weight: bold;
	}

	.ivu-upload {
		display: flex;
		align-items: center;
	}
</style>
